function stern(svg) {
    return svg.path("M5,0 v10 M9.33,7.5 L0.67,2.5 M9.33,2.5 L0.67,7.5");
}
function defineStern(svg) {
    return svg.def(stern(svg).attr("transform", "scale(0.8)").attr("id", "stern"));
}
function sterne(count) {
    return {
        size: [9 * count - 1, 9],
        render: (svg) => {
            const g = defineStern(svg).g();
            for (let i = 0; i < count; i++) {
                g.push(svg.use("#stern").attr("x", 9 * i));
            }
            return g;
        },
    };
}
export const verwaltungsstufen = [
    {
        id: "gemeinde",
        label: "Gemeinde, kreisangehörige Stadt",
        size: [8, 9],
        render: (svg) => svg.g().push(stern(svg).attr("transform", "scale(0.8)")),
    },
    Object.assign({ id: "kreis", label: "Kreis, Landkreis, kreisfreie Stadt" }, sterne(2)),
    Object.assign({ id: "bezirk", label: "Bezirk" }, sterne(3)),
    Object.assign({ id: "land", label: "Land, Freistaat" }, sterne(4)),
    Object.assign({ id: "brd", label: "Bundesrepublik Deutschland" }, sterne(5)),
    {
        id: "eu",
        label: "Europäische Union",
        size: [33, 19],
        render: (svg) => {
            const g = defineStern(svg).g();
            return g
                .push(svg.use("#stern").attr("x", 8))
                .push(svg.use("#stern").attr("y", 5))
                .push(svg.use("#stern").attr("x", 17))
                .push(svg.use("#stern").attr("x", 8).attr("y", 10))
                .push(svg.use("#stern").attr("x", 17).attr("y", 10))
                .push(svg.use("#stern").attr("x", 25).attr("y", 5));
        },
    },
];
